import { render, staticRenderFns } from "./DetailHeader.vue?vue&type=template&id=79e7eddf&scoped=true&"
import script from "./DetailHeader.vue?vue&type=script&lang=js&"
export * from "./DetailHeader.vue?vue&type=script&lang=js&"
import style0 from "./DetailHeader.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DetailHeader.vue?vue&type=style&index=1&id=79e7eddf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e7eddf",
  null
  
)

export default component.exports